<template>
  <div>
    <div class="content">
      <div class="title">添加工作经历</div>
      <div class="cont">
        <div class="box">
          <div class="name"><span class="red">* </span>公司名称</div>
          <div class="inpBox">
            <input
              type="text"
              v-model="info.companyname"
              placeholder="请填写公司名称"
            />
          </div>
        </div>
        <div class="box">
          <div class="name"><span class="red">* </span>职位名称</div>
          <div class="inpBox">
            <input
              type="text"
              v-model="info.jobs"
              mode="month"
              placeholder="请填写职位名称"
            />
          </div>
        </div>
        <!-- <div class="box">
          <div class="name">所属类别</div>
          <div class="selectBox" @click="qwClick">
            <div class="contBox">
              <div class="text" v-if="qwData.length == 0">请选择</div>
              <div class="li dis-cent" v-for="(item, index) in qwData">
                <div class="name">{{ item.categoryname }}</div>
                <div
                  class="iconfont icon-close close"
                  @click.stop="qwDelClick(index)"
                ></div>
              </div>
            </div>
            <div class="iconfont icon-barrage barrage dis-cent"></div>
          </div>
        </div> -->
        <!-- <div class="baoguo">
          <div class="box">
            <div class="name">职位名称</div>
            <div class="inpBox">
              <input type="text" mode="month" placeholder="请填写职位名称" />
            </div>
          </div>
          <div class="box">
            <div class="name">期望行业</div>
            <div class="selectBox" @click="tradeClick">
              <div class="contBox">
                <div class="text" v-if="zwData.length == 0">请选择</div>
                <div class="li dis-cent" v-for="(item, index) in zwData">
                  <div class="name">{{ item.tradeTxt }}</div>
                  <div
                    class="iconfont icon-close close"
                    @click.stop="zwDelClick(index)"
                  ></div>
                </div>
              </div>
              <div class="iconfont icon-barrage barrage dis-cent"></div>
            </div>
          </div>
        </div> -->
        <div class="quanBox">
          <div class="name"><span class="red">* </span>在职时间</div>
          <div class="xuanCont">
            <div class="xuanBox">
              <a-month-picker
                v-model="info.start_time"
                :disabledDate="stardisabledDate"
                placeholder="开始时间"
                @change="stronChange"
              />
            </div>
            <div class="jian">-</div>
            <div class="xuanBox">
              <a-month-picker
                v-model="info.end_time"
                :disabledDate="stardisabledDate"
                placeholder="结束时间"
                @change="endonChange"
              />
            </div>
          </div>
        </div>
        <div class="quanBox">
          <div class="name"><span class="red">* </span>工作内容</div>
          <div class="areaBox">
            <textarea
              v-model="info.achievements"
              placeholder="请输入主要工作内容"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="tcBom">
        <div class="qbtn dis-cent" @click="qxClick">取消</div>
        <div class="btn dis-cent" @click="qrClick">确定</div>
      </div>
    </div>
    <!-- <XuanzeHy v-if="qwShow" @show="qwShowJs" :qwData="qwData" /> -->
    <XuanzeZw v-if="zwShow" @show="zwShowJs" :zwData="zwData" />
    <XuanzeLd v-if="ldShow" :ldData="tradeData" @show="ldShowDelClick" />
    <XuanzeLb v-if="qwShow" :num="1" @show="qwShowDelJs" :qwData="qwData" />
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  DatePicker,
  LocaleProvider,
} from "ant-design-vue";
import XuanzeHy from "../component/xuanzeHy.vue";
import XuanzeZw from "../component/xuanzeZw.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; // 引入中文语言包
import XuanzeLd from "../component/xuanzeLd.vue";
import XuanzeLb from "../component/xuanzeLb.vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-range-picker": DatePicker.RangePicker,
    "a-month-picker": DatePicker.MonthPicker,
    "locale-provider": LocaleProvider,
    XuanzeHy,
    XuanzeZw,
    XuanzeLd,
    XuanzeLb,
  },
  name: "",
  data() {
    return {
      zhCN, // 使用中文语言包
      size: "default",
      qwShow: false,
      qwData: [],
      zwShow: false,
      zwData: [],
      addTxt: "请选择",
      qMoneyOn: null,
      qValue: undefined,
      qMoney: [],
      hValue: undefined,
      hMoney: [],
      yValue: undefined,
      yMoney: [],
      startMonth: null,
      endMonth: null,
      achievements: "",
      tradeData: {},
      tradeTxt: "",
      tradeOn: "",
      ldShow: false,
      companyname: "",
      jobs: "",
    };
  },
  props: {
    info: { type: Object, default: {} },
  },
  created() {},
  methods: {
    get() {
      this.companyname;
    },
    tradeClick() {
      this.ldShow = true;
    },
    ldShowDelClick(data) {
      console.log(data);
      this.ldShow = false;
      if (data.tradeOn) {
        this.zwData = [data];
      }
    },
    qwShowDelJs(data) {
      if (data) {
        if (data.data.length != 0) {
          this.qwData = data.data;
          this.zwid = data.data[0].key;
          this.zwTxt = data.data[0].zTxt;
        }
      }
      this.qwShow = false;
    },
    stronChange(e) {
      this.info.start_time = this.$moment(e._d).format("YYYY-MM");
    },
    endonChange(e) {
      this.info.end_time = this.$moment(e._d).format("YYYY-MM");
    },
    stardisabledDate(current) {
      const today = new Date();
      return (
        current &&
        current.year() === today.getFullYear() &&
        current.month() > today.getMonth()
      );
    },
    onChange(e) {
      console.log(e);
    },
    ddClick(e) {
      this.addTxt = e.key;
    },
    // 行业选择
    qwShowJs(data) {
      this.qwShow = false;
      this.qwData = data.data;
    },
    qwClick() {
      this.qwShow = true;
    },
    qwDelClick(i) {
      this.qwData.splice(i, 1);
    },
    // 职业选择
    zwShowJs(data) {
      this.zwShow = false;
      this.zwData = data.data;
    },
    zwClick() {
      this.zwShow = true;
    },
    zwDelClick(i) {
      this.zwData.splice(i, 1);
    },
    qxClick() {
      this.$emit("show");
    },
    qrClick() {
      let data = {
        ...this.info,
      };
      // data.companyname = this.companyname;
      // data.achievements = this.achievements;
      // data.start_time = this.startMonth;
      // data.end_time = this.endMonth;
      // data.jobs = this.jobs;
      if (!data.companyname) {
        this.$message.error("请输入公司名称");
        return;
      }
      if (!data.jobs) {
        this.$message.error("请填写职位名称");
        return;
      }
      if (!data.start_time || !data.end_time) {
        this.$message.error("请选择在职时间");
        return;
      }
      if (!data.achievements) {
        this.$message.error("请填写职位名称");
        return;
      }
      console.log(data);
      data = JSON.stringify(data);
      this.$post("/nozzle/web/member_experience_save", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("操作成功");
          this.$emit("show", 1);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/.ant-input {
  height: 44px !important;
  border-radius: 10px;
  width: 100%;
}
// /deep/.ant-calendar-picker {
//   width: calc(50% - 30px);
// }
/deep/.ant-calendar-range-picker-separator {
  position: relative;
  top: 6px;
}
.content {
  background-color: #f1f5fc;
  padding: 20px 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  .title {
    font-size: 15px;
  }
  .cont {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .baoguo {
      display: flex;
      width: 100%;
    }
    .box {
      width: calc(50% - 30px);
      margin-right: 60px;
      margin-bottom: 20px;
      .selectBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        .contBox {
          width: calc(100% - 50px);
          display: flex;
          flex-wrap: wrap;
          .text {
            height: 38px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            color: #9c9c9c;
            margin-bottom: 2px;
          }
          .hei {
            color: #000;
          }
          .li {
            background-color: #e2e4ec;
            border-radius: 10px;
            height: 38px;
            padding: 0 6px 0 10px;
            margin-right: 2px;
            margin-bottom: 2px;
            color: #000;
            .iconfont {
              position: relative;
              top: 1px;
              font-size: 14px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }
        .barrage {
          width: 50px;
          font-size: 25px;
          cursor: pointer;
          color: #9c9c9c;
        }
      }
      .selectBox:hover {
        border: 1px solid #147ee0;
        .contBox {
          .text {
            color: #147ee0;
          }
        }
      }
      .inpBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        input {
          height: 38px;
          padding: 0 15px;
          width: 100%;
          box-sizing: border-box;
        }
      }
      .inpBox:hover {
        border: 1px solid #147ee0;
      }
    }
    .box:nth-child(2n) {
      margin-right: 0;
    }
    .quanBox {
      width: 100%;
      padding-bottom: 20px;
      .xuanCont {
        display: flex;
        align-items: center;
        margin-top: 15px;
        .xuanBox {
          box-sizing: border-box;
          background-color: #fff;
          width: 150px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .jian {
          margin: 0 12px;
          font-size: 18px;
        }
      }
      .areaBox {
        border: 1px solid #d8d8d8;
        height: 200px;
        background-color: #fff;
        border-radius: 10px;
        margin-top: 15px;
        overflow: hidden;
        padding: 15px;
        box-sizing: border-box;
        textarea {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
    }
  }
  .tcBom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      width: 90px;
      border-radius: 5px;
      height: 40px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
    .qbtn {
      cursor: pointer;
      width: 90px;
      border-radius: 5px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #147ee0;
      color: #147ee0;
      margin-right: 20px;
    }
  }
}
</style>
